import React, { useState, useEffect } from "react";
import { Link, json, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

function LeftComp() {
  const get_oermission_data = useSelector((state) => state);
  const extract_permissions = get_oermission_data.login_Permission.permissions
    ? JSON.parse(get_oermission_data.login_Permission.permissions)
    : "";
  const hr_permission = get_oermission_data.login_Permission.permissions;

  //  const hr_permission_arr =  hr_permission.split(",")

  const hr_permission_arr = Array();
  if (hr_permission) {
    const hr_permission_arr1 = JSON.parse(hr_permission).split(",");
    hr_permission_arr1.map((item, ind) => {
      hr_permission_arr.push(item);
    });
  }

  const [activemenu, setActivemenu] = useState("");
  const [showmenu, setShowmenu] = useState(false);
  const [showReprots, setShowReprots] = useState(false);
  const [showSkillMenu, setShowSkillMenu] = useState(false);
  const [showmenuskill, setShowmenuskill] = useState(false);
  const [showmenuOngoing, setShowmenuOngoing] = useState(false);
  const [showPerformanceMenu, setShowPerformanceMenu] = useState(false);
  const [showreportmenu, setShowreportmenu] = useState(false);
  var systemrole = localStorage.getItem("systemRole");

  const location = useLocation();
  var string = location.search;
  useEffect(() => {
    let tmp = string.substring(1);
    if (tmp == "ems-policy") {
      setShowmenuskill(false);
      setShowApproval(false);
      setShowreportmenu(false);
      setActivemenu(1);
      setShowmenu(true);
      setShowPerformanceMenu(false);
      setShowmenuOngoing(false);
    } else if (tmp == "hsp") {
      setShowApproval(false);
      setShowmenuskill(false);
      setShowreportmenu(false);
      setActivemenu(2);
      setShowmenu(true);
      setShowPerformanceMenu(false);
      setShowmenuOngoing(false);
    } else if (tmp == "isms") {
      setShowApproval(false);
      setShowmenuskill(false);
      setShowreportmenu(false);
      setActivemenu(3);
      setShowmenu(true);
      setShowPerformanceMenu(false);
      setShowmenuOngoing(false);
    } else if (tmp == "qualitypolicy") {
      setShowApproval(false);
      setShowmenuskill(false);
      setShowreportmenu(false);
      setActivemenu(4);
      setShowmenu(true);
      setShowPerformanceMenu(false);
      setShowmenuOngoing(false);
    } else if (tmp == "codeofconduct") {
      setShowApproval(false);
      setShowmenuskill(false);
      setShowreportmenu(false);
      setActivemenu(5);
      setShowmenu(true);
      setShowPerformanceMenu(false);
      setShowmenuOngoing(false);
    } else if (tmp == "empmanual") {
      setShowApproval(false);
      setShowmenuskill(false);
      setShowreportmenu(false);
      setActivemenu(6);
      setShowmenu(true);
      setShowPerformanceMenu(false);
      setShowmenuOngoing(false);
    } else if (tmp == "modern-slavery") {
      setShowApproval(false);
      setShowmenuskill(false);
      setShowreportmenu(false);
      setActivemenu(35);
      setShowmenu(true);
      setShowPerformanceMenu(false);
      setShowmenuOngoing(false);
    } else if (tmp == "anti-corruption") {
      setShowApproval(false);
      setShowmenuskill(false);
      setShowreportmenu(false);
      setActivemenu(36);
      setShowmenu(true);
      setShowPerformanceMenu(false);
      setShowmenuOngoing(false);
    } else if (tmp == "posh") {
      setShowApproval(false);
      setShowmenuskill(false);
      setShowreportmenu(false);
      setActivemenu(37);
      setShowmenu(true);
      setShowPerformanceMenu(false);
      setShowmenuOngoing(false);
    } else if (tmp == "csr") {
      setShowApproval(false);
      setShowmenuskill(false);
      setShowreportmenu(false);
      setActivemenu(38);
      setShowmenu(true);
      setShowPerformanceMenu(false);
      setShowmenuOngoing(false);
    } else if (tmp == "deib") {
      setShowApproval(false);
      setShowmenuskill(false);
      setShowreportmenu(false);
      setActivemenu(39);
      setShowmenu(true);
      setShowPerformanceMenu(false);
      setShowmenuOngoing(false);
    } else if (tmp == "groups") {
      setShowApproval(false);
      setShowmenu(false);
      setShowreportmenu(false);
      setActivemenu(7);
      setShowSkillMenu(true);
      setShowPerformanceMenu(false);
      setShowmenuOngoing(false);
    } else if (tmp == "subSkill") {
      setShowApproval(false);
      setShowmenu(false);
      setShowreportmenu(false);
      setActivemenu(8);
      setShowSkillMenu(true);
      setShowPerformanceMenu(false);
      setShowmenuOngoing(false);
    } else if (tmp == "ongoingFrom") {
      setShowmenuOngoing(true);
      setShowApproval(false);
      setShowmenuskill(false);
      setShowmenu(false);
      setShowreportmenu(false);
      setActivemenu(53);
      setShowSkillMenu(false);
      setShowPerformanceMenu(false);
    } else if (tmp == "ongoinglist") {
      setShowmenuOngoing(true);
      setShowApproval(false);
      setShowmenu(false);
      setShowreportmenu(false);
      setShowmenuskill(false);
      setActivemenu(54);
      setShowSkillMenu(false);
      setShowPerformanceMenu(false);
    } else if (tmp == "dashboardPanel") {
      setActivemenu(56);
      setShowPerformanceMenu(true);
      setShowSkillMenu(false);
      setShowSkillMenu(false);
      setShowmenuOngoing(false);
    } else if (tmp == "allocationsList") {
      setActivemenu(57);
      setShowPerformanceMenu(true);
      setShowmenuOngoing(false);
      setShowSkillMenu(false);
      setShowmenuOngoing(false);
    } else if (tmp == "kra") {
      setActivemenu(58);
      setShowPerformanceMenu(true);
      setShowmenuOngoing(false);
    } else if (tmp == "kpi") {
      setActivemenu(59);
      setShowPerformanceMenu(true);
      setShowmenuOngoing(false);
    } else if (tmp == "performanceList") {
      setActivemenu(60);
      setShowPerformanceMenu(true);
      setShowmenuOngoing(false);
    } else {
      setShowPerformanceMenu(false);
      setShowmenuOngoing(false);
      setShowmenu(false);
      setShowApproval(false);
      setShowSkillMenu(false);
      setShowmenuskill(false);
      setShowReprots(false);
      setShowreportmenu(false);
      if (window.location.pathname == "/holidaylist") {
        setActivemenu(21);
      }
      if (window.location.pathname == "/momentsqbs") {
        setActivemenu(22);
      }
      if (window.location.pathname == "/feed-news") {
        setActivemenu(23);
      }
      if (window.location.pathname == "/resetpassword") {
        setActivemenu(24);
      }
      if (window.location.pathname == "/employeelist") {
        setActivemenu(25);
      }
      if (window.location.pathname == "/quotelist") {
        setActivemenu(26);
      }
      if (window.location.pathname == "/emp-attendance-approval-list") {
        setShowmenuskill(false);
        setShowmenu(false);
        setShowApproval(true);
        setActivemenu(27);
      }
      if (window.location.pathname == "/emp-leave-approval-list") {
        setShowmenuskill(false);
        setShowmenu(false);
        setShowApproval(true);
        setActivemenu(33);
      }
      if (window.location.pathname == "/qbsconnecttalklist") {
        setActivemenu(28);
      }
      if (window.location.pathname == "/location") {
        setActivemenu(29);
      }
      if (window.location.pathname == "/policy") {
        setActivemenu(1);
        setShowmenu(true);
      }
      if (window.location.pathname == "/skills") {
        setActivemenu(6);
        setShowSkillMenu(true);
      }
      if (window.location.pathname == "/permission") {
        setActivemenu(30);
        setShowSkillMenu(true);
      }
      if (window.location.pathname == "/onboarding") {
        setActivemenu(31);
        setShowSkillMenu(true);
      }
      if (window.location.pathname == "/userreports") {
        setActivemenu(32);
        setShowReprots(true);
        setShowreportmenu(true);
      }
      if (window.location.pathname == "/userloginreports") {
        setActivemenu(34);
        setShowReprots(true);
        setShowreportmenu(true);
      }
    }
  }, [location]);

  // useEffect(()=>{ /empattendance
  // 	alert(showmenu)
  // },[])
  const showPolicy = () => {
    // setShowmenuskill(!showmenuskill)
    setShowmenu(!showmenu);
    // alert(showmenu)
    // setShowApproval(!showApproval)
    // setShowmenuskill(!showmenuskill)
  };

  const showSkills = () => {
    // setShowmenu(!showmenu)
    // alert(showmenuskill)
    setShowmenuskill(!showmenuskill);
    // setShowmenu(!showmenu)
    // setShowApproval(!showApproval)
  };
  const showOngoing = () => {
    // setShowmenu(!showmenu)
    // alert(showmenuskill)
    setShowmenuOngoing(!showmenuOngoing);
    // setShowmenu(!showmenu)
    // setShowApproval(!showApproval)
  };
  const showPerformance = () => {
    setShowPerformanceMenu(!showPerformanceMenu);
  };

  const showReport = () => {
    setShowreportmenu(!showreportmenu);
  };

  const [showApproval, setShowApproval] = useState(false);
  const showApprovalmenu = () => {
    setShowApproval(!showApproval);
    // setShowmenu(!showmenu)
    // setShowmenuskill(!showmenuskill)
  };

  return (
    <div id="sidebar">
      <nav id="sidebarMenu" className="d-md-block sidebar">
        <div className="position-sticky">
          <ul className="nav flex-column">
            {hr_permission_arr?.includes("6") && (
              <li className="nav-item">
                <button
                  className={`btn btn-toggle nav-link ${
                    showmenu ? "active" : ""
                  } align-items-center`}
                  data-bs-toggle="collapse"
                  data-bs-target="#home-collapse"
                  aria-expanded={`${showmenu ? "true" : "false"}`}
                  onClick={showPolicy}
                >
                  Policy
                  <i className="icon icon-chevron-right"></i>
                </button>
                <div
                  className={`collapse submenu ${showmenu ? "show" : ""}`}
                  id="home-collapse"
                >
                  {(hr_permission_arr?.includes("18") ||
                    hr_permission_arr?.includes("19") ||
                    hr_permission_arr?.includes("20") ||
                    hr_permission_arr?.includes("21") ||
                    hr_permission_arr?.includes("22") ||
                    hr_permission_arr?.includes("23")) && (
                    <ul className="">
                      {hr_permission_arr?.includes("18") && (
                        <li>
                          <Link
                            className={` ${activemenu == 1 ? "active" : ""}`}
                            to="/policy?ems-policy"
                          >
                            - EMS Policy
                          </Link>
                        </li>
                      )}
                      {hr_permission_arr?.includes("19") && (
                        <li>
                          <Link
                            className={` ${activemenu == 2 ? "active" : ""}`}
                            to="/policy?hsp"
                          >
                            - Health & Safety Policy
                          </Link>
                        </li>
                      )}
                      {hr_permission_arr?.includes("20") && (
                        <li>
                          <Link
                            className={` ${activemenu == 3 ? "active" : ""}`}
                            to="/policy?isms"
                          >
                            - ISMS Policy Statement
                          </Link>
                        </li>
                      )}
                      {hr_permission_arr?.includes("21") && (
                        <li>
                          <Link
                            className={` ${activemenu == 4 ? "active" : ""}`}
                            to="/policy?qualitypolicy"
                          >
                            - Quality Policy
                          </Link>
                        </li>
                      )}
                      {hr_permission_arr?.includes("22") && (
                        <li>
                          <Link
                            className={` ${activemenu == 5 ? "active" : ""}`}
                            to="/policy?codeofconduct"
                          >
                            - Code Of Conduct
                          </Link>
                        </li>
                      )}

                      {hr_permission_arr?.includes("23") && (
                        <li>
                          <Link
                            className={` ${activemenu == 6 ? "active" : ""}`}
                            to="/policy?empmanual"
                          >
                            - Employee Manual
                          </Link>
                        </li>
                      )}

                      {hr_permission_arr?.includes("23") && (
                        <li>
                          <Link
                            className={` ${activemenu == 35 ? "active" : ""}`}
                            to="/policy?modern-slavery"
                          >
                            - Modern Slavery
                          </Link>
                        </li>
                      )}

                      {hr_permission_arr?.includes("23") && (
                        <li>
                          <Link
                            className={` ${activemenu == 36 ? "active" : ""}`}
                            to="/policy?anti-corruption"
                          >
                            - Anti-Corruption
                          </Link>
                        </li>
                      )}
                      {hr_permission_arr?.includes("23") && (
                        <li>
                          <Link
                            className={` ${activemenu == 37 ? "active" : ""}`}
                            to="/policy?posh"
                          >
                            - POSH Policy
                          </Link>
                        </li>
                      )}
                      {hr_permission_arr?.includes("23") && (
                        <li>
                          <Link
                            className={` ${activemenu == 38 ? "active" : ""}`}
                            to="/policy?csr"
                          >
                            - CSR Policy
                          </Link>
                        </li>
                      )}
                      {hr_permission_arr?.includes("23") && (
                        <li>
                          <Link
                            className={` ${activemenu == 39 ? "active" : ""}`}
                            to="/policy?deib"
                          >
                            - DEIB Statement
                          </Link>
                        </li>
                      )}
                    </ul>
                  )}
                </div>
              </li>
            )}
            {hr_permission_arr?.includes("7") && (
              <li className="nav-item">
                <button
                  className={`btn btn-toggle nav-link ${
                    showmenuskill ? "active" : ""
                  } align-items-center`}
                  data-bs-toggle="collapse"
                  data-bs-target="#skill-collapse"
                  aria-expanded={`${showmenuskill ? "true" : "false"}`}
                  onClick={showSkills}
                >
                  Skills
                  <i className="icon icon-chevron-right"></i>
                </button>
                <div
                  className={`collapse submenu ${showmenuskill ? "show" : ""}`}
                  id="skill-collapse"
                >
                  {(hr_permission_arr?.includes("24") ||
                    hr_permission_arr?.includes("25")) && (
                    <ul className="">
                      {hr_permission_arr?.includes("24") && (
                        <li>
                          <Link
                            className={` ${activemenu == 7 ? "active" : ""}`}
                            to="/skills?groups"
                          >
                            Skill Set
                          </Link>
                        </li>
                      )}
                      {hr_permission_arr?.includes("25") && (
                        <li>
                          <Link
                            className={` ${activemenu == 8 ? "active" : ""}`}
                            to="/skills?subSkill"
                          >
                            Sub Skills
                          </Link>
                        </li>
                      )}
                    </ul>
                  )}
                </div>
              </li>
            )}
            {/* {hr_permission_arr?.includes("31") && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 31 ? "active" : ""}`}
                  to="/onboarding"
                >
                  Onboarding Process
                </Link>
              </li>
            )} */}
            {hr_permission_arr?.includes("52") && (
              <li className="nav-item">
                <button
                  className={`btn btn-toggle nav-link ${
                    showmenuOngoing ? "active" : ""
                  } align-items-center`}
                  data-bs-toggle="collapse"
                  data-bs-target="#ongoing-collapse"
                  aria-expanded={`${showmenuOngoing ? "true" : "false"}`}
                  onClick={showOngoing}
                >
                  Ongoing
                  <i className="icon icon-chevron-right"></i>
                </button>
                <div
                  className={`collapse submenu ${showmenuOngoing ? "show" : ""}`}
                  id="ongoing-collapse"
                >
                  {hr_permission_arr?.includes("52") && (
                    <ul className="">
                      {hr_permission_arr?.includes("53") && (
                        <li>
                          <Link
                            className={` ${activemenu == 53 ? "active" : ""}`}
                            to="/requestForm?ongoingFrom"
                          >
                            Request Form
                          </Link>
                        </li>
                      )}
                      {hr_permission_arr?.includes("54") && (
                        <li>
                          <Link
                            className={` ${activemenu == 54 ? "active" : ""}`}
                            to="/RequestList?ongoinglist"
                          >
                            Request List
                          </Link>
                        </li>
                      )}
                    </ul>
                  )}
                </div>
              </li>
            )}
            {hr_permission_arr?.includes("55") && (
              <li className="nav-item">
                <button
                  className={`btn btn-toggle nav-link ${
                    showPerformanceMenu ? "active" : ""
                  } align-items-center`}
                  data-bs-toggle="collapse"
                  data-bs-target="#performance-collapse"
                  aria-expanded={`${showPerformanceMenu ? "true" : "false"}`}
                  onClick={showPerformance}
                >
                  Performance Management
                  <i className="icon icon-chevron-right"></i>
                </button>
                <div
                  className={`collapse submenu ${showPerformanceMenu ? "show" : ""}`}
                  id="performance-collapse"
                >
                  {hr_permission_arr?.includes("55") && (
                    <ul className="">
                      {hr_permission_arr?.includes("56") && (
                        <li>
                          <Link
                            className={` ${activemenu == 56 ? "active" : ""}`}
                            to="/PerformancePanel?dashboardPanel"
                          >
                            Dashboard Panel
                          </Link>
                        </li>
                      )}
                      {hr_permission_arr?.includes("57") && (
                        <li>
                          <Link
                            className={` ${activemenu == 57 ? "active" : ""}`}
                            to="/Allocation?allocationsList"
                          >
                            Production Daily Performance
                          </Link>
                        </li>
                      )}
                      {hr_permission_arr?.includes("60") && (
                        <li>
                          <Link
                            className={` ${activemenu == 60 ? "active" : ""}`}
                            to="/hod/performance?performanceList"
                          >
                            HOD Daily Performance
                          </Link>
                        </li>
                      )}
                      {hr_permission_arr?.includes("58") && (
                        <li>
                          <Link
                            className={` ${activemenu == 58 ? "active" : ""}`}
                            to="/KRA?kra"
                          >
                            KRA
                          </Link>
                        </li>
                      )}
                      {hr_permission_arr?.includes("59") && (
                        <li>
                          <Link
                            className={` ${activemenu == 59 ? "active" : ""}`}
                            to="/kPI?kpi"
                          >
                            KPI
                          </Link>
                        </li>
                      )}

                      {/* {hr_permission_arr?.includes("55") && (
                        <li>
                          <Link
                            className={` ${activemenu == 58 ? "active" : ""}`}
                            to="/manager/performance?employee"
                          >
                            Daily Performance
                          </Link>
                        </li>
                      )} */}
                    </ul>
                  )}
                </div>
              </li>
            )}
            {hr_permission_arr?.includes("8") && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 25 ? "active" : ""}`}
                  to="/employeelist"
                >
                  Employee List
                </Link>
              </li>
            )}
            {hr_permission_arr?.includes("9") && (
              // <li className="nav-item">
              //   <Link
              //     to="/empattendance"
              //     className={`nav-link ${activemenu == 27 ? "active" : ""}`}
              //   >
              //     Leave Approval
              //   </Link>
              // </li>
              <li className="nav-item">
                <button
                  className={`btn btn-toggle nav-link ${
                    showApproval ? "active" : ""
                  } align-items-center`}
                  data-bs-toggle="collapse"
                  data-bs-target="#home-collapse-approval"
                  aria-expanded={`${showApproval ? "true" : "false"}`}
                  onClick={showApprovalmenu}
                >
                  Approval
                  <i className="icon icon-chevron-right"></i>
                </button>
                <div
                  className={`collapse submenu ${showApproval ? "show" : ""}`}
                  id="home-collapse-approval"
                >
                  <ul className="">
                    {hr_permission_arr?.includes("9") && (
                      <li>
                        <Link
                          className={` ${activemenu == 27 ? "active" : ""}`}
                          to="/emp-attendance-approval-list"
                        >
                          Regularise Attendance
                        </Link>
                      </li>
                    )}
                    <li>
                      <Link
                        className={` ${activemenu == 33 ? "active" : ""}`}
                        to="/emp-leave-approval-list"
                      >
                        Leave Approval
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
            )}

            {hr_permission?.includes("10") && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 24 ? "active" : ""}`}
                  to="/resetpassword"
                >
                  Reset Password
                </Link>
              </li>
            )}

            {hr_permission?.includes("11") && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 23 ? "active" : ""}`}
                  to="/feed-news"
                >
                  Feed News
                </Link>
              </li>
            )}

            {hr_permission?.includes("12") && (
              <li className="nav-item">
                <Link
                  to="/momentsqbs"
                  className={`nav-link ${activemenu == 22 ? "active" : ""}`}
                >
                  Moments at QBS
                </Link>
              </li>
            )}
            {hr_permission?.includes("13") && (
              <li className="nav-item">
                <Link
                  to="/quotelist"
                  className={`nav-link ${activemenu == 26 ? "active" : ""}`}
                >
                  Quote Of Day
                </Link>
              </li>
            )}

            {/* <li class="nav-item">
					<a class="nav-link" href="confirmationform.html">		
						Confirmation Form
					</a>
				</li> */}
            {hr_permission?.includes("14") && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 21 ? "active" : ""}`}
                  to="/holidaylist"
                >
                  List of Holidays
                </Link>
              </li>
            )}
            {hr_permission?.includes("15") && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 28 ? "active" : ""}`}
                  to="/qbsconnecttalklist"
                >
                  List QBS Connect Talk
                </Link>
              </li>
            )}
            {hr_permission?.includes("16") && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 29 ? "active" : ""}`}
                  to="/location"
                >
                  Location
                </Link>
              </li>
            )}

            {hr_permission?.includes("17") && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 30 ? "active" : ""}`}
                  to="/permission"
                >
                  User Permission
                </Link>
              </li>
            )}

            {/* <li className="nav-item">
              <Link
                className={`nav-link ${activemenu == 30 ? "active" : ""}`}
                to="/usermenu"
              >
                User Menu
              </Link>
            </li> */}

            {/* {(hr_permission?.includes('15')) && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 32 ? "active" : ""}`}
                  to="/userreports"
                >
                  User Reports
                </Link>
              </li>
            )} */}
            {hr_permission?.includes("60") && (
              <li className="nav-item">
                <button
                  className={`btn btn-toggle nav-link ${
                    showreportmenu ? "active" : ""
                  } align-items-center`}
                  data-bs-toggle="collapse"
                  data-bs-target="#report-collapse"
                  aria-expanded={`${showreportmenu ? "true" : "false"}`}
                  onClick={showReport}
                >
                  Reports
                  <i className="icon icon-chevron-right"></i>
                </button>
                <div
                  className={`collapse submenu ${showreportmenu ? "show" : ""}`}
                  id="report-collapse"
                >
                  <ul className="">
                    <li>
                      <Link
                        className={` ${activemenu == 61 ? "active" : ""}`}
                        to="/userreports"
                      >
                        Employee Attendance
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={` ${activemenu == 62 ? "active" : ""}`}
                        to="/userloginreports"
                      >
                        Employee Login
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
            )}
            {/* {(hr_permission?.includes('15')) && (
              <li className="nav-item">
                <Link
                  className={`nav-link ${activemenu == 34 ? "active" : ""}`}
                  to="/userloginreports"
                >
                  User Login Reports
                </Link>
              </li>
            )} */}
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default LeftComp;
